import api from '../api';
import type { SuggestedChange } from '@/store';

export type ChatSource = { title: string; path: string; heading?: string };

export const ChatSend = async (
  messages: Array<{ role: 'user' | 'assistant'; content: string }>,
  context: {
    textContent?: string;
    templateName?: string;
    domain?: string;
    template?: string;
    openField?: string;
    graphs?: string;
    nodeCatalogue?: string;
  },
  intent?: string,
): Promise<{ text: string; sources?: ChatSource[]; changes?: SuggestedChange[] }> => {
  const { data } = await api.post(
    '/chat/send',
    { messages, context, intent },
    { timeout: 60000 },
  );
  return data;
};
